import { LitElement, html } from 'lit';
import { faCode } from '@fortawesome/free-solid-svg-icons';
import { getFAIcon } from '../../masonry-utils';

// eslint-disable-next-line
import styles from '!!lit-css-loader!postcss-loader!sass-loader!./web-share.scss';

class ShareBtn extends LitElement {
  static styles = [styles];

  static get properties() {
    return {
      shareTitle: { type: String },
    };
  }

  constructor() {
    super();
    this.icon = faCode;
    this.color = '#aaa';
  }

  connectedCallback() {
    super.connectedCallback();
    this.style.setProperty('--web-share-color', this.color);
  }

  clickHandler = async () => {
    window.open(
      this.shareURL,
      '',
      'toolbar=no, location=no, status=no, menubar=no, resizable=no, width=550, height=400'
    );
  };

  render() {
    return html`
      <button class="web-share__btn" @click=${this.clickHandler}>${getFAIcon(this.icon)}</button>
    `;
  }
}

export default ShareBtn;
